import React from 'react';
import { IOldIconProps } from './type';

const ShoppingCartOutline: React.FC<IOldIconProps> = ({ ...props }) => {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      style={{ verticalAlign: 'middle' }}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M.669 6.681a.75.75 0 11.627-1.362l3.042 1.4a3.75 3.75 0 012.066 2.483l2.376 9.352a2.25 2.25 0 002.181 1.696h13.262a2.25 2.25 0 002.159-1.614l2.615-8.886H12a.75.75 0 010-1.5h17.985a.745.745 0 01.402.107.75.75 0 01.327.872l-2.893 9.83a3.745 3.745 0 01-1.267 1.879A3.773 3.773 0 0128.11 24c0 2.055-1.632 3.75-3.681 3.75-2.05 0-3.681-1.695-3.681-3.75 0-.84.273-1.62.736-2.25h-6.81c.462.63.736 1.41.736 2.25 0 2.055-1.632 3.75-3.681 3.75-2.05 0-3.681-1.695-3.681-3.75a3.78 3.78 0 011.128-2.702 3.748 3.748 0 01-1.85-2.374L4.95 9.572a2.25 2.25 0 00-1.24-1.49L.67 6.682zm8.879 17.32c0-1.26.993-2.25 2.18-2.25 1.189 0 2.181.99 2.181 2.25 0 1.259-.992 2.25-2.18 2.25-1.188 0-2.181-.991-2.181-2.25zm14.88-2.25c-1.187 0-2.18.99-2.18 2.25 0 1.259.993 2.25 2.18 2.25 1.189 0 2.181-.991 2.181-2.25 0-1.26-.992-2.25-2.18-2.25z"
      />
    </svg>
  );
};

export default ShoppingCartOutline;
